export default __webpack_public_path__ + "static/canon_full-af80fd4a70b78ac4e9e22f4b7eca88fd.jpg";